exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-contact{padding-top:6.5rem;padding-bottom:0;position:relative}@media (min-width:48em){.text-contact{padding-top:8.5rem;padding-bottom:0}}@media (min-width:76.8em){.text-contact{padding-top:15rem;padding-bottom:0}}@media (min-width:99.2em){.text-contact{padding-top:17.5rem;padding-bottom:0}}.text-contact .contacts{padding-top:2rem}@media (min-width:48em){.text-contact .contacts{padding-top:0}}.text-contact .contacts .line{display:none}@media (min-width:48em){.text-contact .contacts .line{display:block}}.text-contact .contacts p{font-size:1.6rem;line-height:3.2rem;margin-bottom:2rem}@media (min-width:48em){.text-contact .contacts p{margin-bottom:4rem}}.text-contact .contacts p:last-of-type{margin-bottom:0}.text-contact .contacts p a{font-weight:200;color:#d94c02}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-TextContact/_index.scss
 ** module id = 203
 ** module chunks = 0
 **/